export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Search-Gray-cd779ccae0454289cea91ef13d2f449b.svg";